/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/**
* author: hao
*/

import {
  CHANGE_LANGUAGE,
  TOGGLE_MENU,
  SAVE_APPINFO,
  SAVE_RETRVINFO,
  SAVE_BUSINESSINFO,
  SAVE_SECTIONINFO,
  SHOW_LOADING,
  HANDLE_ERROR,
  SAVE_COUNTRYLIST,
  SAVE_ALLCOUNTRYLIST,
  CLEAR_ERROR,
  GET_APP_MESSAGE,
  SAVE_INDUSTRYLEVELLIST,
  HANDLE_INPUTERROR,
  UPDATE_QIANHAI_INFO,
  SAVE_STATUS,
  SAVE_RESORBUSOPESITCODELEVEL_LIST
} from './action';
import { SAVE_AO_FORM, COMPLETE_AO_FORM } from '../../AOForm/state/action';
import { getCountryListFormLang } from '../../../utils'

const initalState = {
  isOpen: false,
  isDisplayInputErr: false,
  inputErrCode: null,
  errLocation: null
}
const app = (state = initalState, action) => {
  switch (action.type) {
    case GET_APP_MESSAGE:
      { return { ...state, i18n: action.data } }
    case CHANGE_LANGUAGE:
      { return { ...state, selectedLanguage: action.selectedLanguage } }
    case TOGGLE_MENU:
      { return { ...state, isOpen: !state.isOpen } }
    case SAVE_APPINFO:
      { return { ...state, applicationInfo: action.applicationInfo } }
    case SAVE_RETRVINFO:
      { return { ...state, retrvInfo: action.retrvInfo } }
    case SAVE_BUSINESSINFO:
      { return { ...state, businessInfo: action.businessInfo } }
    case SAVE_SECTIONINFO:
      { return { ...state, sectionInfo: action.sectionInfo } }
    case SAVE_COUNTRYLIST:
      { 
        const result = getCountryListFormLang(action.countryListDatas, action.lang)
        return { ...state, countryListDatas: result } 
      }
    case SAVE_ALLCOUNTRYLIST:
      { return { ...state, allCountryDatas: action.allCountryDatas } }
    case SAVE_INDUSTRYLEVELLIST:
      { return { ...state, industryLevelList: action.industryLevelList } }
    case SAVE_RESORBUSOPESITCODELEVEL_LIST:
      { return { ...state, resOrBusOpeSitCodeLevelDatasRoots: action.resOrBusOpeSitCodeLevelDatasRoots } }
    case SAVE_AO_FORM:
    case COMPLETE_AO_FORM:
      {
        // merge question status into businessinfo
        const oldBusinessInfo = state.businessInfo;
        const newBusinessInfo = { ...oldBusinessInfo, questionStatus: { ...oldBusinessInfo.questionStatus, ...action.questionStatus } }
        return { ...state, applicationInfo: action.data, businessInfo: newBusinessInfo }
      }
    case SHOW_LOADING:
      { return { ...state, isLoading: action.isDisplay } }
    case HANDLE_ERROR:
      { return { ...state, showSystemError: true, errorCode: action.error.errorCode } }
    case CLEAR_ERROR:
      { return { ...state, showSystemError: false, errorCode: null } }
    case HANDLE_INPUTERROR:
      { return { ...state, isDisplayInputErr: action.isDisplayInputErr, inputErrCode: action.inputErrCode || null, errLocation: action.errLocation || null } }
    case UPDATE_QIANHAI_INFO: {
      // merge qianhai info into businessinfo
      const oldBusinessInfo = state.businessInfo;
      const newBusinessInfo = { ...oldBusinessInfo, qianHaiInfo: { ...action.qianhaiInfo } }
      return { ...state, businessInfo: newBusinessInfo }
    }
     case SAVE_STATUS: 
            return { ...state,applicationInfo: {...state.applicationInfo, ...action.data }
            };
    default:
      return state
  }
}

export default app


// WEBPACK FOOTER //
// ./src/views/App/state/reducer.js